import { HttpRequest, HttpEvent, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable, retry, timer, throwError } from 'rxjs';

export function retryInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const shouldRetry = (error: HttpErrorResponse) => {
    if (error.status >= 500 || error.status === 0) {
      return timer(5000); // Retry after 3 seconds for 500 errors or network errors
    }
    return throwError(() => error); // Throw error if it's not a retryable error
  };

  return next(request).pipe(
    retry({
      count: 5,
      delay: shouldRetry, // Use the delay function for retry
    }),
  );
}
